import React from 'react';
import { Label } from '../../../UiKit';
import { getOrgIdFromUrl } from '../../../utils/UtilFunctions';

const tableHeading = [
  { name: 'User ID', key: 1 },
  { name: 'Karma', key: 2 },
  { name: 'Dispute History', key: 3 },
];

const orgId = getOrgIdFromUrl();

const getUserObj = (user) => {
  const userObj = {
    1: {
      title: (
        <>
          <a
            style={{
              textDecorationLine: 'underline',
              marginRight: '10px',
            }}
            target={'_blank'}
            href={`/lifeline?type=user_id&value=${user.user_id}&org_id=${orgId}`}
            rel='noreferrer'
            className='tw-whitespace-nowrap'
          >
            {user.user_id}
          </a>

          {/* Employee Status */}
          {user?.employee_details?.text ? (
            <div className='tw-text-[1.3rem] tw-border-solid tw-mr-2 tw-text-zinc-600 tw-font-medium tw-border-teal-200 tw-border-[1px] tw-rounded-md tw-bg-teal-100/50 tw-px-3 tw-py-2 tw-whitespace-nowrap tw-leading-none'>
              {user.employee_details.text}
            </div>
          ) : null}

          {/* Blocked Status */}
          {user?.block_status_resp?.block_status ? (
            <div className='tw-mr-2'>
              <Label
                bgColor={user?.block_status_resp.block_status_tag_color}
                title={user?.block_status_resp?.tag}
              />
            </div>
          ) : null}

          {/* Deleted Status */}
          {user?.deleted_status_resp ? (
            <Label
              bgColor={user.deleted_status_resp.tag_color}
              title={user.deleted_status_resp.tag}
              textColor={user.deleted_status_resp.text_color}
            />
          ) : null}
        </>
      ),
    },
    2: {
      title:
        (
          <Label
            textColor={user?.karma?.text}
            title={`${user?.karma?.label} ${
              user?.karma?.score > 0 ? user.karma.score : ''
            }`}
            bgColor={user?.karma?.color}
            showIcon={false}
          />
        ) || '-',
    },
    3: {
      title: (
        <span style={{ color: user?.warning_text.color }}>
          {user?.warning_text?.text || '-'}
        </span>
      ),
    },
  };
  return userObj;
};

const getTableRows = (users) => {
  const rowsData = [];
  users &&
    users.map((user) => {
      const userObj = getUserObj(user);
      rowsData.push(userObj);
    });
  return rowsData;
};

export const getTableData = (transactions) => {
  const tableData = {
    headings: tableHeading,
    rows: getTableRows(transactions),
  };
  return tableData;
};
